module.exports = __webpack_public_path__ + "static/media/BNB_BISON_APE.79c7cad6.png";